module.exports = __webpack_public_path__ + "img/icon_success_confirmation.a7efe6e9.png";